import { EntityActions } from '~/apps/shared/actions/consts';

import * as api from '../apis/balance';
import { apiCall } from '~/lib/redux/api';
import { BalanceActions } from './consts';


// TODO: Use constants and refactor into accounts
export function getBalance() {
  return apiCall({
    actions: [
      BalanceActions.LOAD_REQUEST,
      BalanceActions.LOAD_SUCCESS,
      BalanceActions.LOAD_ERROR,
    ],
    fn: () => api.getBalance(),
  });
}
